import { render, staticRenderFns } from "./PerfilProfissional.vue?vue&type=template&id=ece500e0"
import script from "./PerfilProfissional.vue?vue&type=script&lang=js"
export * from "./PerfilProfissional.vue?vue&type=script&lang=js"
import style0 from "./PerfilProfissional.vue?vue&type=style&index=0&id=ece500e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports